import revealAthletesInfo from '../../../../utils/revealAthletesInfo';

export const revealAthletes = (data: any, filter: any) =>
  revealAthletesInfo(filter?.name ? data?.map((d: any) => d.person?.athleteProfile) : data || []);
